import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import { updateOnBoardingStep, processPayment } from '../../../../actions/user-api';
import * as Loadings from '../../../../constants/loadings/user';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentMethods } from '../../../../_common/payments2';
import {DiscountCode} from './discountCode';

import featuresOverview from './../../../../assets/images/placeholder/Features-Overview.svg';

export const Step6 = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const paymentOptions = [{ num: 1, price: '299,00' }, { num: 4, price: '74,75' }, { num: 6, price: '49,95' }];
    const [selectedOption, setSelectedOption] = useState(paymentOptions[0]);
    const [processing, setProcessing] = useState(false);
    const [discountCodeState, setDiscountCodeState] = useState({
        code: undefined,
        apiId: undefined,
        isValid: undefined,
    });

    async function endRegistration() {
        setProcessing(true)
        if (!user.user.billedByPartner) {
            await dispatch(processPayment(user.user, discountCodeState.apiId, selectedOption.num));
        }
        await dispatch(updateOnBoardingStep(6));
        let tmpUser = user.user;
        let step = !R.isNil(user) && !R.isNil(tmpUser) && !R.isNil(tmpUser.onBoardingStep) ? parseInt(JSON.stringify(tmpUser.onBoardingStep).replace(/\D/g, "")) : -1;
        if (step === 6 || step === -1) {
            if (tmpUser.onBoardingStep === "Completed" || tmpUser.onBoardingStep === 6) {
                setProcessing(false)
                window.location = `/anticipa?fc=1`;
            }
        }
    }
    if(R.isNil(user.user)){
        return '';
    }
    if (user.user.billedByPartner) {
        return (
            <article className="view-calc mb-auto pt-3">
                <div className="auto-view my-auto">
                    <div className="container-fluid">
                        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-gutter text-center">
                            <img className="img-fluid mx-auto container-md-press mb-gutter" src={featuresOverview} alt="features overview" />
                            <div className="container-default mx-auto">
                                <h1 className="text-primary font-weight-bolder mt-0 mb-1">Validation</h1>
                                <p className="h3 mb-0">Résumé de votre dossier.</p>
                            </div>
                        </header>
                        <section className="block container-default mx-auto">
                            <h4 className="fs-3 text-uppercase font-weight-bolder mt-0">Votre tarif comprend :</h4>
                            {/* <h3 className="h3 font-weight-bolder mt-3 mb-2">Votre tarif comprend :</h3> */}
                            <div className="card border-0">
                                <div className="card-body">
                                    <div role="button" className="d-flex align-items-start small">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Création d’un dossier personnalisé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Création, copie et adressage de toutes vos démarches en recommandé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Un espace bibliothèque pour déposer des documents accessibles à tous les proches invités</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Un accès à la plateforme pendant 1 an après le décès</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Modification de vos données incluses</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <footer className="block mt-auto mb-sm text-right w-100">
                    <div className="container-fluid flex-row align-items-center">
                        <Link to="/auth/signup/step5" className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                        {
                            processing ?
                                <button className="btn btn-info px-md-gutter px-4 loading-btn show" disabled>Terminer <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                                :
                                <button className="btn btn-info px-md-gutter px-4 loading-btn" onClick={async () => {
                                    await endRegistration();
                                }}>Terminer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>

                        }
                    </div>
                </footer>
            </article>
        )
    }
    return (
        <article className="view-calc mt-3 mb-auto pt-3 mt-lg-n3 pt-lg-3">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-3">Validation</h1>
                    <h2 className="text-body ls-0 mt-n2 o-50">Résumé de votre dossier</h2>
                </header>
            </div>
            <div className="auto-view my-3">
                <div className="container-fluid">
                    <section className="block">
                        <div className="row gx-2">
                            <div className="col-12 col-lg">

                                <h3 className="h3 text-secondary font-weight-bolder mt-3 mb-1">Mode de paiement</h3>
                                <p className="small o-80">Cliquez ci-dessous pour ajouter ou modifier une méthode de paiement</p>
                                <PaymentMethods user={user.user} loadings={user.isLoading} stripeClientSecret={user.stripeClientSecret} />
                                <hr className="my-gutter" />
                                <DiscountCode discountCodeState={discountCodeState} setDiscountCodeState={setDiscountCodeState} user={user.user} />
                            </div>
                            <div className="col-12 col-lg-auto">
                                <div className="container-lg-narrow">
                                    <h3 className="h3 font-weight-bolder mt-3 mb-2">Votre tarif comprend :</h3>
                                    <div className="card border-0">
                                        <div className="card-body">
                                            <div className="block mb-sm">
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Création de votre dossier personnalisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Archivage dans un coffre-fort numérique sécurisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Suivi et courrier d’information annuel de votre dossier personnalisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Modification de vos données incluses</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Confirmation des coordonnées de votre (vos) mandataire(s) annuellement</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Intérruption de votre abonnement à tout moment</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">En cas de décès : <span className="font-weight-bolder">Création, copie et adressage de toutes vos démarches en recommandé</span></span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start justify-content-between pb-1">
                                                <p className="h5 font-weight-normal my-auto">Organismes de bases</p>
                                                {
                                                    discountCodeState.isValid ?
                                                        <p className="h5 my-auto">0,00 €</p>
                                                        :
                                                        <p className="h5 my-auto">60,00 €</p>
                                                }
                                            </div>
                                            <div className="d-flex align-items-start justify-content-between pt-1">
                                                <p className="h5 font-weight-normal my-auto">Organismes complémentaires</p>
                                                {
                                                    discountCodeState.isValid ?
                                                        <p className="h5 my-auto">0,00 €</p>
                                                        :
                                                        <p className="h5 my-auto">239,00 €</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="card-body pb-2 bg-common text-primary">
                                            <div className="d-flex align-items-start justify-content-between">
                                                <p className="h6 font-weight-bolder my-auto">Total TTC</p>
                                                {
                                                    discountCodeState.isValid ?
                                                        <p className="h2 font-weight-bolder my-auto">0,00 €</p>
                                                        :
                                                        <p className="h2 font-weight-bolder my-auto">299,00 €</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        discountCodeState.isValid ?
                                            ''
                                            :
                                            <div className="card border-0 bg-common text-primary mt-2">
                                                <div className="card-body py-3">
                                                    <h5 className="h5 font-weight-bolder mb-3 pb-2 text-uppercase">Vous pouvez mensualiser votre dossier </h5>
                                                    <form className="d-flex align-items-start justify-content-between">
                                                        <div className="form-inline w-50">
                                                            <select className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded py-0" id="mois" onChange={(e) => {
                                                                e.preventDefault();
                                                                let option = paymentOptions.find(p => p.num.toString() === e.target.value)
                                                                if (option !== null) {
                                                                    setSelectedOption(option);
                                                                }
                                                            }}
                                                                value={selectedOption.num}>
                                                                {paymentOptions.map((option, index) => {
                                                                    return <option key={index} value={option.num}>{option.num}</option>
                                                                })}
                                                            </select>
                                                            {/* <input type="number" className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded" id="mois" placeholder="3" /> */}
                                                            <label className="h6 font-weight-bolder my-auto text-body" htmlFor="mois">mois</label>
                                                        </div>
                                                        <p className="h2 font-weight-bolder my-auto">{selectedOption.price} €</p>
                                                    </form>
                                                </div>
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <footer className="block mt-auto mb-sm text-right w-100">
                <div className="container-fluid flex-row align-items-center">
                    <Link to="/auth/signup/step5" className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                    {
                        R.isEmpty(user.user.paymentMethods) && !discountCodeState.isValid ?
                            <button className="btn btn-info px-md-gutter px-4" disabled>Payer maintenant</button>
                            :
                            user.isLoading.includes(Loadings.PROCESSING_PAYMENT) || processing ?
                                <button className="btn btn-info px-md-gutter px-4 loading-btn show" disabled>Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                                :
                                <button className="btn btn-info px-md-gutter px-4 loading-btn" onClick={async () => {
                                    await endRegistration();
                                }}>Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                    }
                </div>
            </footer>
        </article>
    )
}